export enum OrgDashboardApiIntegrationType {
  GREENHOUSE = 'greenhouse',
  JAZZHR = 'jazzhr',
}

export const orgDashboardApiIntegrationTypes = Object.values(
  OrgDashboardApiIntegrationType,
);

export function isOrgDashboardApiIntegrationTypes(
  integrationType: string,
): integrationType is OrgDashboardApiIntegrationType {
  return orgDashboardApiIntegrationTypes.includes(integrationType);
}
